var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "#1FAB89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5183 18H13.481C15.5617 18 16.6023 18 17.3497 17.51C17.6721 17.2987 17.9499 17.0259 18.167 16.7074C18.6663 15.974 18.6663 14.952 18.6663 12.9094C18.6663 10.866 18.6663 9.8447 18.167 9.11136C17.9499 8.79277 17.6721 8.52003 17.3497 8.3087C16.8697 7.99336 16.2683 7.8807 15.3477 7.8407C14.9083 7.8407 14.5303 7.51403 14.4443 7.0907C14.3786 6.78061 14.2079 6.50272 13.9609 6.304C13.714 6.10527 13.406 5.9979 13.089 6.00003H10.9103C10.2517 6.00003 9.68434 6.4567 9.55501 7.0907C9.46901 7.51403 9.09101 7.8407 8.65167 7.8407C7.73167 7.8807 7.13034 7.99403 6.64967 8.3087C6.32742 8.52007 6.04992 8.79281 5.83301 9.11136C5.33301 9.8447 5.33301 10.866 5.33301 12.9094C5.33301 14.952 5.33301 15.9734 5.83234 16.7074C6.04834 17.0247 6.32567 17.2974 6.64967 17.51C7.39701 18 8.43767 18 10.5183 18ZM11.9997 10.182C10.4657 10.182 9.22167 11.4027 9.22167 12.9087C9.22167 14.4154 10.4657 15.636 11.9997 15.636C13.5337 15.636 14.7777 14.4154 14.7777 12.9094C14.7777 11.4027 13.5337 10.182 11.9997 10.182ZM11.9997 11.2727C11.0797 11.2727 10.333 12.0054 10.333 12.9094C10.333 13.8127 11.0797 14.5454 11.9997 14.5454C12.9197 14.5454 13.6663 13.8127 13.6663 12.9094C13.6663 12.0054 12.9197 11.2727 11.9997 11.2727ZM15.1477 10.7274C15.1477 10.426 15.3963 10.182 15.7037 10.182H16.4437C16.7503 10.182 16.9997 10.426 16.9997 10.7274C16.9983 10.8733 16.939 11.0127 16.8349 11.115C16.7307 11.2172 16.5903 11.2739 16.4443 11.2727H15.7037C15.6314 11.2734 15.5596 11.2599 15.4925 11.2328C15.4255 11.2058 15.3644 11.1658 15.3127 11.1152C15.2611 11.0646 15.2199 11.0042 15.1916 10.9377C15.1633 10.8712 15.1484 10.7997 15.1477 10.7274Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamIcon);
export default __webpack_public_path__ + "static/media/cam-icon.60765e50163a57ae14323d85f1ba0134.svg";
export { ForwardRef as ReactComponent };